<template>
  <!-- 新增v-if="open"為了讓他重啟時刷新狀態 -->
  <div>
    <!-- -------------------主要區塊start ----------------------->
    <section class="container search pt_10 pb_3 px_0">
      <div class="row">
        <div class="col-12">
          <form class="form">
            <div class="input-group input-lg">
              <div class="input">
                <input
                  type="text"
                  name="Search"
                  id="Search"
                  class="form-control"
                  v-model="keyword"
                  @keydown.enter="doSearch()"
                  placeholder="輸入被保險人姓名進行搜尋"
                  alt="ch"
                  style="width: 100%"
                  @input="checkKeyword"
                  @blur="checkKeyword"
                />
                <span id="searchclear" v-show="keyword" @click="cleanSearch()"
                  >清除</span
                >
              </div>
              <button
                class="btn btn-primary btn-icon"
                type="submit"
                @click.prevent="doSearch()"
              >
                <i class="icon-search i-24"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
    <!-- 預設展示 -->
    <div>
      <h4 class="text-green d-flex" v-if="isSearch == 'D'">
        <span class="pt_15 d-inline-block" v-if="isSearch == 'D'"
          >建議書列表</span
        >
      </h4>
      <div class="mt_5 font-weight-bold" v-if="isSearch == 'D'">
        請選擇你想查詢的建議書
      </div>
      <div class="mt_5 text-red fz_13" v-if="isSearch == 'D'">
        60天內未點擊瀏覽的建議書，系統將自動刪除
      </div>
      <div class="pt_10">
        <h4 class="text-green d-flex" v-if="isSearch == 'S'">
          <span class="pt_8 d-inline-block">搜尋結果</span>
          <a class="btn btn-default px_5 py_5 ml_10" @click="cleanSearch()"
            >返回空白建議書列表</a
          >
        </h4>
      </div>
      <div class="row mt_10" v-if="filterNoIDProposalList.length != 0">
        <div
          class="noIdCard mr-4 mt_20"
          v-for="(item, index) in filterNoIDProposalList"
          :key="`group-item-${item.prod_idx}`"
          @click="updateClickDate(item.prod_idx, item.prod_type)"
        >
          <div class="noIdCard__head d-flex">
            {{ item.createROCdate }} {{ item.createtime }}
            <div class="btn btn-default" @click="deleteProposal(item)">
              <img src="@/desktop/views/mf/assets/trash.svg" alt="" />
            </div>
          </div>
          <div class="noIdCard__insured mt_10" @click="toDetail(item)">
            被保人:<span class="text-green text-underline">{{
              truncate(item.insured_name)
            }}</span>
          </div>
          <div class="d-flex justify-content-end mt_5">
            <Avatar
              class="mr-2"
              :gender="Number(item.insured_gender)"
              :size="20"
              :height="20"
            />
            <strong>{{
              (item.insured_age || item.insured_age === 0
                ? item.insured_age
                : "--") + "歲"
            }}</strong>
          </div>
          <div class="noIdCard__info mt_10">
            <div
              class="btn btn-primary ProposalInfoButton"
              :tabindex="index"
              @click="showInfoData(index, item.prod_type)"
              @focusout="
                item.showInfo = false;
                $forceUpdate();
              "
            >
              商品資訊
              <div class="ProposalInfoWrap">
                <div
                  class="ProposalInfoToast"
                  v-show="item.showInfo"
                  :tabindex="index"
                  @blur="
                    item.showInfo = false;
                    $forceUpdate();
                  "
                >
                  <div
                    class="ProposalInfoToast__mc"
                    v-for="(mc, index) in item.mc_prod_list"
                    :key="mc.mc_idx"
                  >
                    <div class="ProposalInfoToast__mc__index mt_5">
                      建議{{ index + 1 }}:
                    </div>
                    <div>
                      {{ mc.prod_name }}{{ `(${mc.prod_id})`
                      }}<template v-if="mc.job_cat && mc.job_cat != ''">{{
                        `(職業類別:${mc.job_cat}類)`
                      }}</template>
                    </div>
                    <div v-if="mc.prod_type != '1' && mc.hasOwnProperty('amt')">
                      <!-- //投資型 -->
                      (繳費方式:{{ getPay_freq_nm(mc.pay_freq) }} / 基本保額:{{
                        formatMethods(mc.amt)
                      }}{{ $amtUnitToNm(mc.amt_unit) }})
                    </div>
                    <div
                      v-else-if="
                        mc.prod_type != '1' && !mc.hasOwnProperty('amt')
                      "
                    >
                      <!-- //投資型 -->
                      (繳費方式:{{ getPay_freq_nm(mc.pay_freq) }} )
                    </div>
                    <div v-else>
                      <!-- 傳統型 -->
                      (繳費年期:{{ mc.pay_prd }}年 / 保額:{{
                        formatMethods(mc.amt)
                      }}{{ $amtUnitToNm(mc.amt_unit) }})
                    </div>
                    <div v-if="mc.sc_prod_list.length > 0">
                      搭配附約:{{ mc.sc_prod_list.length }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="text-center d-flex justify-content-center mt-5"
        colspan="6"
      >
        <div
          :class="{ 'h2w3 mt-4 section-loading': custsOfAgntIsLoading }"
        ></div>
        <h3 class="mb-3 pre-formatted">{{ this.remoteDataMessage }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from "@/desktop/components/Avatar";
import mf_Mixin from "@/desktop/views/mf/mixin";
import moment from "moment";
export default {
  name: "QueryNoId",
  mixins: [mf_Mixin],
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  components: { Avatar },

  data() {
    return {
      isSearch: "D", //判斷頁面與Button( D為展示預設，S為搜尋結果)
      keyword: "", //搜尋條件
      remoteDataMessage: "'資料讀取中，請稍候...", //遠端資料訊息
      custsOfAgntIsLoading: false, //是否在搜尋中
      noIDProposalList: [],
    };
  },
  computed: {
    filterNoIDProposalList() {
      if (this.isSearch == "S") {
        return this.noIDProposalList.filter((item) => {
          return item.insured_name.indexOf(this.keyword) > -1;
        });
      } else {
        return this.noIDProposalList;
      }
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    moment,
    async init() {
      //初始化
      this.remoteDataMessage = "資料讀取中，請稍候...";
      this.custsOfAgntIsLoading = true;

      const result = await this.$mfAPI.MFA0_1000__queryNoIDProposalList({
        agent_id: this.$store.state.userInfo.id,
      });
      this.noIDProposalList = result.no_id_proposal_list;
      this.remoteDataMessage = "無任何建議書";
      this.custsOfAgntIsLoading = false;
      this.registerHanlink(); // for 難字更新
    },
    async doSearch() {
      if (this.keyword === "") {
        this.isSearch = "D";
        return;
      }
      this.isSearch = "S";
      this.custsOfAgntIsLoading = true;
      this.registerHanlink(); // for 難字更新
    },
    cleanSearch() {
      this.keyword = "";
      this.isSearch = "D";
      this.init();
    },
    checkKeyword() {
      this.keyword = this.checkSpecialKeyword(this.keyword);
    },
    deleteProposal(target) {
      this.$mfNotice(
        "您確定要刪除這份建議書嗎?",
        () => {
          if (target.prod_type == "1") {
            //傳統型刪除
            this.$mfAPI
              .MFA0_1000__deleteProposal({ prod_idx: target.prod_idx })
              .then(() => {
                this.$toast.info({ title: "刪除成功" });
                this.init();
              });
          } else {
            ////投資型刪除
            this.$mfAPI
              .MFA1_1000__deleteProposal({ prod_idx: target.prod_idx })
              .then(() => {
                this.$toast.info({ title: "刪除成功" });
                this.init();
              });
          }
        },
        true
      );
    },
    async showInfoData(index, prod_type) {
      //使用filter後清單更新
      if (this.filterNoIDProposalList[index].mc_prod_list) {
        this.filterNoIDProposalList[index].showInfo = true;
        this.$forceUpdate();
      } else {
        let res;
        switch (prod_type) {
          case "1":
            //傳統型
            res = await this.$mfAPI.MFA0_1000__queryProposalDetailList({
              agent_id: this.$store.state.userInfo.id,
              insured_id: "",
              prod_idx: this.filterNoIDProposalList[index].prod_idx,
            });
            this.filterNoIDProposalList[index] = {
              ...res.proposal[0],
              ...this.filterNoIDProposalList[index],
            };
            break;
          default:
            // 投資型(XHA)
            res = await this.$mfAPI.MFA1_1000__queryProposalDetailList({
              agent_id: this.$store.state.userInfo.id,
              insured_id: "",
              prod_idx: this.filterNoIDProposalList[index].prod_idx,
            });
            this.filterNoIDProposalList[index] = {
              ...res.proposal[0],
              ...this.filterNoIDProposalList[index],
            };
            break;
        }
        this.filterNoIDProposalList[index].showInfo = true;
        this.$forceUpdate();
      }
    },
    toDetail(item) {
      this.$store.commit("update_queryDetailTarget", {
        is_crm: "0",
        insured_id: "",
        prod_idx: item.prod_idx,
        familyid: "",
      });
      this.$router.push("/mf/query/queryDetail");
    },
  },
};
</script>

<style lang="scss">
#searchclear {
  position: absolute;
  right: 40px;
  top: 16px;
  bottom: 0;
  margin-right: 58px;
  cursor: pointer;
  font-size: 15px;
  color: #048f3a;
  text-decoration: underline;
}
.noIdCard {
  flex-shrink: 0;
  width: 211px;
  border-radius: 8px;
  padding: 5px 10px 10px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15);
  border: solid 1px #989ca2;
  background-color: #fff;
  &__head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    color: #989ca2;
    .btn {
      margin: 0;
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-grow: 0;
      flex-shrink: 0;
      width: 30px;
      height: 30px;
    }
  }
  &__insured {
    font-size: 18px;
    font-weight: 700;
    white-space: nowrap;
    cursor: pointer;
  }
  &__info .btn {
    margin: 0;
    width: 100%;
    min-height: 40px;
  }
}
.ProposalInfoButton {
  position: relative;
  .ProposalInfoWrap {
    position: absolute;
    left: 0;
    bottom: 30px;
    z-index: 99;
    .ProposalInfoToast {
      width: 240px;
      padding: 10px;
      border-radius: 4px;
      box-shadow: 3px 3px 3px 0 rgba(0, 0, 0, 0.16);
      border: solid 1px #fff;
      background-color: #fff;
      color: #323a45;
      text-align: left;
      line-height: 1.38;
      &__mc__index {
        font-weight: 700;
        font-size: 18px;
      }
    }
  }
}
</style>
